import { yupResolver } from "@hookform/resolvers/yup";
import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SettingsRootParamList } from "../../../../types";
import { useLocalSettingsProvider } from "../../../../utilities/local-settings";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { validationSchema } from "./constants";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import React from "react";

type FormValues = Yup.InferType<typeof validationSchema>;

export interface EditStockcountDestinationEmailScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "EditStockcountDestinationEmailScreen"
  > {}

export const EditStockcountDestinationEmailScreen = ({
  navigation,
}: EditStockcountDestinationEmailScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const { settings, setSetting } = useLocalSettingsProvider();
  const { stockcountDestinationEmail = "" } = settings;
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();

  const globalSettings = useGlobalSettingsProvider();
  const { stocktakeSendToAddress = "" } = globalSettings;
  const [value, setValue] = React.useState(stocktakeSendToAddress || "");

  const isValid = React.useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }, [value]);

  const isDirty = React.useMemo(() => {
    return value != stocktakeSendToAddress;
  }, [value, stocktakeSendToAddress]);

  const handleOnSave = React.useCallback(async () => {
    if (!isValid) return;
    return updateGlobalSettings({
      stocktakeSendToAddress: value,
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value, isValid]);

  useEffect(() => {
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: "Edit Default Stockcount Email",
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={!isValid || !isDirty}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, isDirty, handleOnSave]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Send to Address"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
      />
    </Page>
  );
};
